import React from 'react'
import { plusMinus, getMerchantInfo } from '@util'
import { PUBLISH_MEAL_PATH_A } from '@constant'

export default (tabArray, tab) => [
  {
    title: <p>{tabArray[tab]}名称</p>,
    dataIndex: 'title',
    render: (title, { id, second_category_id }) => (
      <a
        href={
          tab == 0
            ? `${PUBLISH_MEAL_PATH_A}/${id}?weddingPhotoType=${second_category_id}`
            : tab == 1
              ? `#/localMerchant/case/detail/${id}?propertyId=${
                  getMerchantInfo().property_id
                }`
              : `#/localMerchant/addressStyle/edit/${id}`
        }
        target="_blank"
        rel="noopener noreferrer"
      >
        {title}
      </a>
    )
  },
  {
    title: 'CTR',
    dataIndex: 'ctr',
    sorter: true
  },
  {
    title: '行业排名',
    dataIndex: 'ranking',
    sorter: true
  },
  {
    title: <p>{tabArray[tab]}质量分</p>,
    dataIndex: 'score',
    sorter: true
  },
  {
    title: '日环比',
    dataIndex: 'compare',
    sorter: true,
    render: compare => (
      <p style={{ color: plusMinus(compare) }}>{compare || 0}</p>
    )
  },
  {
    title: '操作',
    dataIndex: 'is_show',
    render: (is_show, { id, second_category_id }) => (
      <a
        href={
          tab == 0
            ? `${PUBLISH_MEAL_PATH_A}/${id}?weddingPhotoType=${second_category_id}`
            : tab == 1
              ? `#/localMerchant/case/detail/${id}?propertyId=${
                  getMerchantInfo().property_id
                }`
              : `#/localMerchant/addressStyle/edit/${id}`
        }
        target="_blank"
        rel="noopener noreferrer"
      >
        编辑
      </a>
    )
  }
]
